import React from 'react';
import './CustomAlert.css';

export default function CustomAlert({ show, onClose, title, message, type = 'info' }) {
  if (!show) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'warning':
        return '⚠';
      case 'info':
      default:
        return 'ℹ';
    }
  };

  const getIconClass = () => {
    switch (type) {
      case 'success':
        return 'alert-icon-success';
      case 'error':
        return 'alert-icon-error';
      case 'warning':
        return 'alert-icon-warning';
      case 'info':
      default:
        return 'alert-icon-info';
    }
  };

  return (
    <div className="custom-alert-overlay" onClick={onClose}>
      <div className="custom-alert-modal" onClick={(e) => e.stopPropagation()}>
        <div className={`custom-alert-icon ${getIconClass()}`}>
          {getIcon()}
        </div>
        {title && <h2 className="custom-alert-title">{title}</h2>}
        <p className="custom-alert-message">{message}</p>
        <button className="custom-alert-button" onClick={onClose}>
          Got it
        </button>
      </div>
    </div>
  );
}
